export const checkIds = (ids, arr) => {
	if (!ids || !arr) return;

	const filter = arr.filter((item) => ids.includes(item.id));

	if (filter.length !== ids.length) return false;

	return true;
};
